import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import ListAssignment from './List';
import UpdateTimeWindow from './UpdateTimeWindow';
import ListAssignmentShipments from './ListShipment';
import { Box, Typography, Container } from '@mui/material';

export default function AssignmentRoot() {
  return (
    <Container style={{ height: 'calc(100% - 65px)' }}>
      <Box py={2} px={1}>
        <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
          Assignments List
        </Typography>
      </Box>
      <UpdateTimeWindow />
      <ListAssignment />
      <Routes>
        <Route
          path=":id/shipments"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ListAssignmentShipments />
            </Suspense>
          }
        />
      </Routes>
    </Container>
  );
}
